import React from 'react';
import { Dropdown } from 'semantic-ui-react';

export interface CmDropdownOption<T extends string | number> {
  value: T;
  text: React.ReactNode;
}

export interface CmDropdownProps<T extends string | number> {
  value: T;
  options: readonly CmDropdownOption<T>[];
  onChange: (value: T) => void;
  placeholder?: string;
  disabled?: boolean;
  testId?: string;
  ariaLabel?: string;
}

export function CmDropdown<T extends string | number>({
  value,
  options,
  onChange,
  placeholder,
  disabled = false,
  testId,
  ariaLabel,
}: CmDropdownProps<T>): React.ReactElement {
  return (
    <Dropdown
      selection
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      options={options.map((o) => ({ key: String(o.value), value: o.value, text: o.text }))}
      onChange={(_, data) => onChange(data.value as T)}
      data-testid={testId}
      aria-label={ariaLabel}
    />
  );
}

export default CmDropdown;
